
import { Vue, Component, Prop } from 'vue-property-decorator';

@Component
export default class LabelTag extends Vue {
  @Prop({ required: true }) text!: string;

  @Prop({ default: '#2BC5CB' }) color!: string;

  @Prop({ default: '' }) className!: string;

  @Prop({ default: 'default' }) variant!: 'default' | 'textOnly';
}
